import { useState } from 'react';
import { MapPin } from 'lucide-react';
import { useMutation } from '@tanstack/react-query';
import { useFilters } from '@/contexts/FilterContext';
import { useAuth } from '@/contexts/AuthContext';
import { areaRequestsApi } from '@/api/endpoints/area-requests';
import { Button } from './Button';

export function NoAreaCoverage() {
  const { lat, lng } = useFilters();
  const { isAuthenticated } = useAuth();
  const [submitted, setSubmitted] = useState(false);

  const { mutate, isPending, error } = useMutation({
    mutationFn: () => areaRequestsApi.submit({ latitude: lat!, longitude: lng! }),
    onSuccess: () => setSubmitted(true),
  });

  const errorMessage = error instanceof Error ? error.message : null;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="mb-4 opacity-50">
        <MapPin size={48} className="text-[var(--color-muted)]" />
      </div>
      <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">
        Bar Guide isn't in your area yet
      </h2>
      <p className="text-sm text-[var(--color-muted)] max-w-sm leading-relaxed mb-4">
        We're expanding to new cities! Let us know you're interested and we'll prioritize your area.
      </p>
      {submitted ? (
        <div className="px-4 py-2 rounded-lg bg-[var(--color-bg-secondary)]">
          <span className="text-sm font-medium text-[var(--color-text)]">
            Requested! We'll keep you posted.
          </span>
        </div>
      ) : isAuthenticated ? (
        <Button onClick={() => mutate()} disabled={isPending}>
          {isPending ? 'Submitting...' : 'Request Coverage'}
        </Button>
      ) : (
        <p className="text-sm text-[var(--color-muted)]">
          Sign in to request coverage for your area.
        </p>
      )}
      {errorMessage && (
        <p className="mt-2 text-sm text-red-500">{errorMessage}</p>
      )}
    </div>
  );
}
